module.exports = __webpack_public_path__ + "img/clock-epoch.6a8cd224.svg";